/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { makeStyles } from "@fluentui/react-components";

export enum TrialActionId {
    LearnMore = 'LearnMore',
    TryCopilotDialog = 'TryCopilotDialog',
    BrainStormDialog = 'BrainStormDialog'
}

export const useTrialConversionStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: '360px',
        margin: '0 auto',
        background: 'transparent',
    },
    welcomeTitle: {
        fontSize: '14px',
        fontWeight: '700',
        marginBottom: '8px',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
});

